import { render } from "./ProjectInteractionModal.vue?vue&type=template&id=2b03a55b&scoped=true"
import script from "./ProjectInteractionModal.vue?vue&type=script&lang=js"
export * from "./ProjectInteractionModal.vue?vue&type=script&lang=js"

import "./ProjectInteractionModal.vue?vue&type=style&index=0&id=2b03a55b&scoped=true&lang=css"

import exportComponent from "D:\\Work\\Contractly\\Contractly.Site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b03a55b"]])

export default __exports__